/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { saveCropCounter, saveFormAvatar } from '../../../app/page/page-storage/users/user-form/user-form.actions';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelect, useSelectWithParams } from '../../../utils/selector.utils';
import { meetingsSimplePageSelectors } from '../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { clearUpdateMeetingSimpleComplete } from '../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { MeetingForm } from '../../pages/MeetingPage/MeetingForm';
import { ConnectedDialog } from '../ConnectedDialog';
import { IMeetingFormDialogProps } from './types';
import { IMeetingSimpleUpdate } from '../../../app/resource/meeting-simple/meeting-simple.types';

export const MeetingFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'meetingFormDialog') as IMeetingFormDialogProps;
  const loaderState = props && props.data ? 'updateMeetingSimple' : 'createMeetingSimple';
  const [error] = useApiRequestState(loaderState);
  const isUpdateMeetingComplete = useSelect(meetingsSimplePageSelectors.selectIsUpdateMeetingComplete);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorCheck, updateErrorCheck] = useState(false);
  const newCB = useCallback((check) => {
    updateErrorCheck(check);
    //updateErrorCheck(false);
  }, []);
  const onClick = useCallback(
    (check) => {
      updateErrorCheck(check);
      setTimeout(function () {
        newCB(false);
      }, 1500);
    },
    [newCB],
  );

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingFormDialog'));
    dispatch(saveFormAvatar(''));
    dispatch(saveCropCounter(0));
  }, [dispatch]);

  // React to successful meeting update
  useEffect(() => {
    if (isUpdateMeetingComplete) {
      setIsSubmitting(false);
      dispatch(clearUpdateMeetingSimpleComplete());
    }
  }, [isUpdateMeetingComplete, dispatch]);

  const handleSubmit = useCallback(
    (data: IMeetingSimpleUpdate) => {
      setIsSubmitting(true);
      if (props?.onSubmit) {
        props.onSubmit(data);
      }
    },
    [props],
  );

  return (
    <ConnectedDialog dialogKey="meetingFormDialog">
      <div className="popup new_team_popup mid-popup isVisible">
        <div className="panel" style={{ minWidth: '710px' }}>
          <div className="panel-header small-header flex jcsb">
            <h3>
              {props?.data ? 'Edit' : 'New'} {props?.type === 'account' ? 'Account' : 'Meeting'}
            </h3>
            <span className="close-popup close">
              {isSubmitting && <span className="css-loader--meeting-dashboard-navbar"></span>}
              {error && !isSubmitting && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body pt-0" style={{ maxHeight: '500px' }}>
            <MeetingForm {...props} onSubmit={handleSubmit} errorCheck={errorCheck} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" title="" onClick={onClose}>
              Close
            </a>
            <div style={{ width: 105, height: 45, display: 'flex', alignItems: 'center' }}>
              <button
                form="meeting-form"
                type="submit"
                className="btn btn-green"
                title=""
                style={isSubmitting ? { display: 'none' } : { display: 'block' }}
                onClick={() => onClick(true)}
              >
                Save
              </button>
              {isSubmitting && (
                <span className="css-loader--meeting-dashboard-navbar" style={{ height: '30px', width: '30px' }}></span>
              )}
            </div>
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
